import React, { useState } from 'react';
import RequestPreviewPresenter from './RequestForQuotationPreviewDialogPresenter';
import Loading from '@components/Loading/LoadingPresenter';

import useRequest from '@hooks/useRequest';
import { useForm } from 'react-hook-form';
import useUserActionLog, {
  CapaActivityType,
  Enum_Action_Button_Enum
} from '@hooks/useUserActionLog';

import { useRequestRfqIdQuery } from '@generated/graphql';

const RequestPreviewContainer = (props: {
  open: boolean;
  onClose: () => void;
}) => {
  const [submitLoading, setSubmitLoading] = useState(false);

  const { handleSubmit } = useForm();
  const {
    requestState,
    onUpdateRfqInfo,
    onCompleteRfq,
    insertRFQ
  } = useRequest();

  const { loading } = useRequestRfqIdQuery({
    onCompleted: (resp) => {
      if (resp.requestRfqId.data?.uuid) {
        onUpdateRfqInfo({
          ...requestState,
          rfqId: resp.requestRfqId.data?.uuid
        });
      }
    },
    fetchPolicy: 'network-only'
  });

  const { onInsertUserActionLogOne } = useUserActionLog();

  const submitData = async () => {
    onCompleteRfq();
    onUpdateRfqInfo({ ...requestState });
    setSubmitLoading(true);
    await insertRFQ();
    setSubmitLoading(false);
  };
  const onSubmit = handleSubmit(submitData);

  if (loading) return <Loading open={true} />;

  return (
    <React.Fragment>
      <Loading open={submitLoading} />

      <RequestPreviewPresenter
        open={props.open}
        onClose={props.onClose}
        onSubmit={(e) => {
          onInsertUserActionLogOne(
            Enum_Action_Button_Enum[
              `Button_RFQ_${requestState.serviceType}_Submit` as keyof typeof Enum_Action_Button_Enum
            ],
            CapaActivityType.ButtonClick
          );

          e?.persist();
          return onSubmit(e)!;
        }}
      />
    </React.Fragment>
  );
};
export default RequestPreviewContainer;
